import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useEventCallback, useEventListener } from 'usehooks-ts'

import AccountIcon from '@wwt/shared/assets/icons/outline/account.svg'

import { cn } from '@/shared/lib/cn'
import { useSession } from '@/shared/lib/hooks/useSession'
import { Button, ButtonProps } from '@/shared/ui/Button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuTrigger
} from '@/shared/ui/DropdownMenu'

import { AccountSettingsItem } from './items/AccountSettings'
import { ChatItem } from './items/Chat'
import { LogOutItem } from './items/LogOut'
import { MyTravelsItem } from './items/MyTravels'
import { RestartTutorialItem } from './items/RestartTutorial'
import { TranslationsItem } from './items/Translations'

export interface AccountButtonProps extends ButtonProps {
	slots?: {
		base?: string
		content?: string
	}
}

export const AccountButton = ({
	className,
	slots,
	...props
}: AccountButtonProps) => {
	const { t } = useTranslation('header')

	const token = useSession.use.token()

	const [open, setOpen] = useState(false)

	const handleViewportResize = useEventCallback(() => {
		if (window.innerWidth < 1280) {
			setOpen(false)
		}
	})

	useEventListener('resize', handleViewportResize)

	return (
		<DropdownMenu
			open={open}
			onOpenChange={setOpen}
		>
			<DropdownMenuTrigger asChild>
				<Button
					className={cn(className, slots?.base)}
					variant="tertiary"
					size="icon-sm"
					data-wwt-id="header__account--button"
					{...props}
				>
					<AccountIcon />
					<span className="sr-only">{t('accountMenu.open')}</span>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				className={cn('max-xl:hidden', slots?.content)}
				side="bottom"
				align="end"
			>
				<AccountSettingsItem />
				<MyTravelsItem />
				<ChatItem />
				<RestartTutorialItem />
				<TranslationsItem />
				{token && <LogOutItem />}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
